// extracted by mini-css-extract-plugin
module.exports = {"specifications":"ProductSpecifications_specifications__RpTt2"};